
    import '/home/ec2-user/Youlify-Design/components/app/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["app-demo-basic","app-demo-config"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/app/index.zh-CN.md?type=demo')
};